var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVitualBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.13742 3.33594C4.59539 3.33594 4.09098 3.62166 3.82213 4.08247L2.14585 6.94994C1.85193 7.27905 1.66797 7.70323 1.66797 8.17245V14.7957C1.66797 15.8291 2.53082 16.6693 3.59133 16.6693H6.89359C7.62762 16.6693 8.29159 16.2399 8.58171 15.5784L9.32887 14.1201C9.43719 13.869 9.68925 13.7063 9.96801 13.7063C10.2468 13.7063 10.4988 13.8682 10.6086 14.1201L11.4224 15.5784C11.7102 16.2399 12.3742 16.6693 13.109 16.6693H16.4113C17.4718 16.6693 18.3346 15.8283 18.3346 14.7957V8.17245C18.3344 7.84769 18.2406 7.54643 18.0905 7.2798L18.1009 7.27402L16.176 4.06655C15.9045 3.61521 15.406 3.33594 14.8696 3.33594H5.13742ZM5.13742 4.81742H14.8696V4.81887L15.7588 6.2989H4.2719L5.13742 4.81742ZM6.21302 10.0026C7.05007 10.0026 7.72804 10.6656 7.72804 11.4841C7.72804 12.3026 7.05007 12.9656 6.21302 12.9656C5.37597 12.9656 4.698 12.3026 4.698 11.4841C4.698 10.6656 5.37597 10.0026 6.21302 10.0026ZM13.7881 10.0026C14.6252 10.0026 15.3031 10.6656 15.3031 11.4841C15.3031 12.3026 14.6252 12.9656 13.7881 12.9656C12.9511 12.9656 12.2731 12.3026 12.2731 11.4841C12.2731 10.6656 12.9511 10.0026 13.7881 10.0026Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVitualBg);
export default __webpack_public_path__ + "static/media/Vitual Bg.fb87e5e62c4ba9853ad67007553d6544.svg";
export { ForwardRef as ReactComponent };